<template>
    <SidebarItem v-if="isCallCenter()" icon="users" link="/admin/users" :label="$t('admin.sidebar.users')" />
    <SidebarItem icon="feedbacks" link="/admin/feedbacks" :label="$t('admin.sidebar.feedbacks')" :badgeCount="$store.state.feedback.count" />
    <SidebarItem icon="chat" link="/admin/chat" :label="$t('admin.sidebar.chat')" :badgeCount="$store.state.chat.newChatCount" />
    <SidebarItem icon="questionaree" link="/admin/questionnaire" :label="$t('admin.sidebar.questionnaire')" />
    <SidebarItem
        :badgeCount="$store.state.feedback.countSupport"
        icon="technical_support"
        link="/admin/technical_support"
        :label="$t('admin.sidebar.technical_support')"
    />
    <SidebarItem v-if="isCallCenter()" icon="orders" link="/admin/orders" :label="$t('admin.sidebar.orders')" />
    <SidebarItem v-if="isCallCenter()" icon="promo_codes" link="/admin/promo-codes" :label="$t('admin.sidebar.promo_codes')" />
</template>

<script setup>
    import SidebarItem from '@/components/sidebar/SidebarItem.vue';
    import { onMounted } from 'vue';
    import { useChatSocket, useFeedbackSocket } from '@/services/socket';
    import { useStore } from 'vuex';
    import { isCallCenter } from '@/utils/role';

    const store = useStore();
    onMounted(() => {
        //listen call center role socket
        store.dispatch('chat/getCounts');
        store.dispatch('feedback/getCounts');
        store.dispatch('feedback/getTechnicalSupportCounts');

        useChatSocket(() => {
            store.dispatch('chat/getCounts');
        });

        useFeedbackSocket(() => {
            store.dispatch('feedback/getCounts');
        });
    });
</script>
